import { call, put, takeLatest } from 'redux-saga/effects';
import { cloneDeep } from 'lodash';

import { objToFormData } from 'utils';
import { SettingsGlobal } from '../../../../entities/Settings/interfaces';
import { SettingsService } from '../../../../entities/Settings/services';
import {
  getGlobalSetError,
  getGlobalSetSuccess,
  putGlobalSetRequest,
  putGlobalSetSuccess,
  putGlobalSetError,
  getGlobalSetRequest,
} from './actions';
import { GET_GLOBAL_SETTINGS_REQUEST, PUT_GLOBAL_SETTINGS_REQUEST } from './constants';

function* getGlobalSettings() {
  try {
    const settings: SettingsGlobal = yield call(SettingsService.getSettingsGlobal);

    yield put(getGlobalSetSuccess(settings));
  } catch (error: any) {
    yield put(getGlobalSetError(error));
  }
}

function* updateGlobalSettings(action: ReturnType<typeof putGlobalSetRequest>) {
  try {
    const data = cloneDeep(action.payload);

    yield call(SettingsService.putSettingsGlobal, objToFormData(data));
    yield put(putGlobalSetSuccess());
    yield put(getGlobalSetRequest());
  } catch (error: any) {
    yield put(putGlobalSetError(Error(error?.message || 'Виникла помилка')));
  }
}

export function* settingsGlobSagaWatcher() {
  yield takeLatest(GET_GLOBAL_SETTINGS_REQUEST, getGlobalSettings);
  yield takeLatest(PUT_GLOBAL_SETTINGS_REQUEST, updateGlobalSettings);
}
